/**
 * WCAG 2.4.1 "Bypass Blocks" skip link. Invisible in the normal flow;
 * becomes a visible focused chip when keyboard users Tab on page load.
 * Anchored to the nearest landmark with id="main" on every shell.
 *
 * Using an <a href> (not a button) so the native jump-to-id behaviour
 * works even if JS is slow to hydrate — progressively enhanced.
 */
export default function SkipToMain({ targetId = "main", label = "Skip to main content" }) {
  return (
    <a
      data-testid="skip-to-main"
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary/30"
    >
      {label}
    </a>
  );
}
